import { SharedIcon } from '@/components/SharedIcon/SharedIcon';
import { ResourceSet } from '../hooks/resourceSetHooks';

const ExternalResourceInfoIcon = ({
  resourceSet,
}: {
  resourceSet: ResourceSet;
}) => {
  if (!resourceSet.is_external_resource) {
    return null;
  } else if (resourceSet.external_resource_info_out_of_date) {
    return (
      <SharedIcon
        iconName="info"
        size="sm"
        title={
          'This resource is not being updated by ALMIS as scheduled. Check ALMIS to see if this resource still exists.'
        }
        aria-label={
          'This resource is not being updated by ALMIS as scheduled. Check ALMIS to see if this resource still exists.'
        }
        style={{ cursor: 'default', color: 'var(--warning)' }}
      />
    );
  } else {
    return (
      <SharedIcon
        iconName="info"
        size="sm"
        title={'This resource is being updated by ALMIS.'}
        aria-label={'This resource is being updated by ALMIS.'}
        style={{ cursor: 'default' }}
      />
    );
  }
};

export default ExternalResourceInfoIcon;
